(function () {
  'use strict';
  $(document).ready(function () {

    // Script to adjust background of slider-journeys-wrapper

    $('.slider-journeys-wrapper').each(function () {
      var $this = $(this),
        element_h = $this.outerHeight(),
        background_w = 1000,
        background_h = 667,
        speedFactor = 0.7,
        ratio = background_w / background_h;

      var adjustbackground = function () {
        var window_height = $(window).height();

        element_h = $this.outerHeight();
        background_h = element_h + window_height * (1 - speedFactor);
        background_w = background_h * ratio;
        if (background_w < $this.width()) {
          background_w = $this.width();
          background_h = background_w / ratio;
        }
        $this.css({
          backgroundSize: 'auto ' + background_h + 'px'
        });
      };

      var doScroll = function () {
        if ($(window).width() < 768) {
          return;
        }
        var delta = Math.round(isappears($this) * (1 - speedFactor));

        if (delta > 0) {
          var background_y = $this.outerHeight() - background_h + delta;

          $this.css({
            backgroundPosition: '50% ' + background_y + 'px'
          });
        }
      };

      adjustbackground();
      doScroll();
      $(window).bind({
        scroll: function () {
          doScroll();
        },
        load: function () {
          adjustbackground();
          doScroll();
        },
        resize: function () {
          adjustbackground();
        }
      });
    });

    function isappears(element) {
      var scrolltop = $(window).scrollTop(),
        top = $(element).offset().top;

      if (top < $(window).height()) {
        return scrolltop;
      }
      if ((scrolltop + $(window).height()) >= ($(element).offset().top)) {
        return scrolltop + $(window).height() - $(element).offset().top;
      }
      return 0;
    }

    // Script to run journeys-slider
    var journeyContainer = $('.journeys-slider');

    if (journeyContainer.length) {

      var options = {
        auto: true,
        controls: false,
        infiniteLoop: true,
        maxSlides: 1,
        minSlides: "1",
        mode: "horizontal",
        moveSlides: "1",
        nextText: '<span class="fa fa-angle-right"></span>',
        pager: false,
        pause: "6000",
        prevText: '<span class="fa fa-angle-left"></span>',
        randomStart: false,
        slideMargin: 20,
        slideWidth: 720,
        speed: "500",
        touchEnabled: false,
        startSlide: "0",
        onSliderLoad: function () {
          $('.slider-journeys-wrapper .tp-loader').hide();
          $('.slider-journeys-wrapper').css('visibility', 'visible');
        }
      };

      var jmbxAdjustOptions = function(options, container_width) {
        var _options = {};

        $.extend(_options, options);
        if ((_options.slideWidth * _options.maxSlides + (_options.slideMargin * (_options.maxSlides - 1))) < container_width) {
          _options.slideWidth = (container_width - (_options.slideMargin * (_options.maxSlides - 1))) / _options.maxSlides;
        } else {
          _options.maxSlides = Math.floor((container_width - (_options.slideMargin * (_options.maxSlides - 1))) / _options.slideWidth);
          _options.maxSlides = _options.maxSlides == 0 ? 1 : _options.maxSlides;
          _options.slideWidth = (container_width - (_options.slideMargin * (_options.maxSlides - 1))) / _options.maxSlides;
        }
        return _options;
      };

      var waitForFinalEvent = (function () {
        var d = {};

        return function (a, b, c) {
          if (!c) {
            c = "Don't call this twice without a uniqueId"
          }
          if (d[c]) {
            clearTimeout(d[c]);
          }
          d[c] = setTimeout(a, b);
        }
      })();


      var journeySlide = journeyContainer.bxSlider(jmbxAdjustOptions(options, journeyContainer.innerWidth()));
      var windowW = $(window).width();

      $(window).resize(function () {
        waitForFinalEvent(function () {
          if (windowW == $(window).width()) return;
          windowW = $(window).width();
          journeySlide.destroySlider();
          journeySlide = journeyContainer.bxSlider(jmbxAdjustOptions(options, journeyContainer.innerWidth()));
        }, 50, 'journeySlider');
      });
    }

  });

}());
